import classNames from 'classnames/bind';
import styles from './CardSideFront.module.scss';
import { Grid, Image, PlusIcon } from '@/components';
import React from 'react';
import { WordPressBlocksViewer } from '@faustwp/blocks';
let cx = classNames.bind(styles);

export default function CardSideFront({ cardAttr, innerBlocks }) {

  const multipleColumns = innerBlocks[0]?.innerBlocks.length > 1 ? true : false;

  const bgImageFitMobile = cardAttr.mobileBackgroundImageSettings?.objectFit && cardAttr.mobileBackgroundImageSettings?.objectFit[0];
  const bgImageFitDesk = cardAttr.backgroundImageSettings?.objectFit && cardAttr.backgroundImageSettings?.objectFit[0];
	
  const mobileBgAspectRatio = cardAttr.mobileBackgroundImage && bgImageFitMobile === 'contain' ? cardAttr.mobileBackgroundImage.node.mediaDetails.width / cardAttr.mobileBackgroundImage.node.mediaDetails.height : null;
	const deskBgAspectRatio = !multipleColumns && cardAttr.backgroundImage && bgImageFitDesk === 'contain' ? cardAttr.backgroundImage.node.mediaDetails.width / cardAttr.backgroundImage.node.mediaDetails.height : null;


	return (
		<>
			<div className={cx(['card-front', (bgImageFitMobile === 'cover' || !bgImageFitMobile && bgImageFitDesk === 'cover') && 'background-cover--mobile', bgImageFitDesk === 'cover' && 'background-cover--desk', cardAttr.alignItemsMobile && `align-items-${cardAttr.alignItemsMobile}-mobile`, cardAttr.alignItemsDesktop && `align-items-${cardAttr.alignItemsDesktop}-desk`, multipleColumns && 'muli-column-card'])}>
				<div className={cx('content-container')}>{React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] })}</div>
				{cardAttr.flipCard && (
					<>
						<i className={cx('plus-icon')} tabIndex="0">
							<PlusIcon />
						</i>
						<span className="sr-only">Open to read more.</span>
					</>
				)}
				{cardAttr.mobileBackgroundImage && <Image image={cardAttr.mobileBackgroundImage} objectFit={bgImageFitMobile} fill={true} objectPosition={`${cardAttr.mobileBackgroundImageSettings?.objectPositionX}% ${cardAttr.mobileBackgroundImageSettings?.objectPositionY}%`} className={cx(['card-background--mobile'])} style={mobileBgAspectRatio && { aspectRatio: `${mobileBgAspectRatio}` }} />}
				{cardAttr.backgroundImage && <Image image={cardAttr.backgroundImage} objectFit={bgImageFitDesk} fill={true} objectPosition={`${cardAttr.backgroundImageSettings?.objectPositionX}% ${cardAttr.backgroundImageSettings?.objectPositionY}%`} className={cx(['card-background', cardAttr.backgroundImageSettings?.hideOnMobile && 'hide-mobile', cardAttr.backgroundImageSettings?.hideOnDesktop && 'hide-desk'])} style={deskBgAspectRatio && { aspectRatio: `${deskBgAspectRatio}` }} />}
			</div>
		</>
	);
}
